import { useEffect, useState } from "react";
import { todayInIndia } from "./enquiryValidation";

// Static pages can be opened after the build date. Start with the same markup
// on both sides, then apply the current date without replacing the page.
export function useTodayInIndia() {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => { setHydrated(true); }, []);
  return hydrated ? todayInIndia() : undefined;
}
